import React from 'react';
import Configurer from '../../components/Configurer';
import FormViewer from '../../components/FormViewer';
import LoaderButton from '../../components/LoaderButton';
import HttpServices from '../../utils/Http.services';
import { translate } from '../../utils/useful';

const CHANGE_PRICE_HEADERS = [
  { key: 'percentage', type: 'NumberInput', col: '12', information: { label: '{{lang}}Percentage', placeholder: '{{lang}}Percentage', hint: 'Positive to increase, negative to decrease', required: true }, showMain: true },
  { key: 'category', type: 'SelectInput', col: '4', information: { label: '{{lang}}Category', address: 'getCategories', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Category', required: false }, showMain: true },
  { key: 'supplier', type: 'SelectInput', col: '4', information: { label: '{{lang}}Supplier', address: 'getPartners', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Supplier', required: false }, showMain: true },
  { key: 'brand', type: 'SelectInput', col: '4', information: { label: '{{lang}}Brand', address: 'getBrands', filter: {}, fields: { title: 'title', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Brand', required: false }, showMain: true },
];

class AdminChangePrice extends React.Component {
  state = {
    isLoading: false,
    errors: {},
    formKey: 0,
  };

  submitChangePrice = () => {
    if (!this.form) return;
    const data = this.form.getForm();
    if (!data) return;

    const payload = {
      percentage: data.percentage,
      category: data.category,
      supplier: data.supplier,
      brand: data.brand,
    };

    this.setState({ isLoading: true, errors: {} });

    HttpServices.request(this.props.page?.submitUrl || 'changeProductPrices', payload, (fetchResult, fetchError) => {
      this.setState({ isLoading: false });

      if (fetchError) {
        this.props.addNotif({ type: 'error', title: translate('Error'), description: fetchError.message });
        return;
      }

      this.props.addNotif({ type: 'success', title: translate('Success'), description: translate('Prices updated successfully') });
      this.setState({ formKey: this.state.formKey + 1 });
    });
  };

  render() {
    return (
      <Configurer
        settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: translate('Change Price'), button: { goBack: true } }}
        title={translate('Change Price')}
        description={translate('Bulk update product prices by percentage')}
        className=""
      >
        <div className="container">
          <div className="row m-0 w-100">
            <div className="col-12 col-md-8 col-lg-6">
              <FormViewer
                key={this.state.formKey}
                ref={(el) => (this.form = el)}
                headers={CHANGE_PRICE_HEADERS}
                errors={this.state.errors}
                variables={this.props.variables}
              />

              <div className="mt-4">
                <LoaderButton
                  onClick={this.submitChangePrice}
                  isLoading={this.state.isLoading}
                  text={translate('Apply')}
                  className=""
                  buttonStyle={{ padding: '10px 24px', borderRadius: 8 }}
                />
              </div>
            </div>
          </div>
        </div>
      </Configurer>
    );
  }
}

export default AdminChangePrice;
